<form [formGroup]="formGroup">

    <app-form-field [type]="fields.name.type" [options]="fields.name.options"></app-form-field>
	<app-form-field [type]="fields.type.type" [options]="fields.type.options"></app-form-field>
	<app-form-field  *ngIf="isAdmin" [type]="fields.client_id.type" [options]="fields.client_id.options"></app-form-field>
	<app-form-field [type]="fields.reel_categories_id.type" [options]="fields.reel_categories_id.options"></app-form-field>
	<app-form-field [type]="fields.groups_id.type" [options]="fields.groups_id.options"></app-form-field>
	<app-form-field [type]="fields.layoutIdScreenId.type" [options]="fields.layoutIdScreenId.options"></app-form-field>
	<app-form-field [type]="fields.active.type" [options]="fields.active.options"></app-form-field>
</form>

<div class="modal-footer">
    <button class="btn btn-success" (click)="submit()" [disabled]="!formGroup.valid"><i class="fa fa-save"></i> Guardar</button>
    <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>
